import { render, staticRenderFns } from "./edit_icon_alt2.vue?vue&type=template&id=8e2bba74&"
import script from "./edit_icon_alt2.vue?vue&type=script&lang=ts&"
export * from "./edit_icon_alt2.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports